import * as React from "react"

const FullscreenOff = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M6.501 8.999a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.854.354l-5-5A.501.501 0 0 1 1.5 9h5ZM14.499 9a.5.5 0 0 1 .354.854l-5 5a.5.5 0 0 1-.854-.354v-5a.5.5 0 0 1 .5-.5h5ZM6.501 1a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.354-.854l5-5A.503.503 0 0 1 6.5 1Zm2.998 0a.5.5 0 0 1 .354.146l5 5a.5.5 0 0 1-.354.854h-5a.5.5 0 0 1-.5-.5v-5a.501.501 0 0 1 .5-.5Z" />
  </svg>
)

export default FullscreenOff
